import React from "react";
import assets from "../assets/assets";   // change to banner2 or banner3 if you prefer

const ImageHero = () => {
  return (
    <>
      {/* Full-width hero with a single background image */}
      <div
        style={{
          position: "relative",
          height: "130vh",                // keep your original height
          width: "100%",
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(${assets.banner1})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {/* Fixed Center Tagline – stays on top of the image */}
        <h1
          style={{
            position: "absolute",
            top: "35%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontFamily: "Playfair, serif",
            fontSize: "clamp(2.8rem, 6vw, 4rem)",
            fontWeight: "bold",
            textAlign: "center",
            width: "90%",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
          Enter a World Where Every Journey Wears Your Signature
        </h1>
      </div>

      {/* Content Below the hero image */}
      <div
        style={{
          maxWidth: "900px",
          margin: "60px auto",
          padding: "20px",
          lineHeight: "1.7",
          color: "var(--color-primary)",
          textAlign: "justify",
        }}
      >
        <p>
          Discover the art of exceptional travel, where every moment is crafted
          with elegance and every journey feels effortlessly exclusive. Your trip
          is more than a holiday to us—it's an experience we take personal
          responsibility for.
        </p>
        <p>
          At <strong style={{ color: "var(--color-primary)" }}>Sha tours,</strong> we
          bring genuine care to every interaction, tailoring each part of your
          itinerary to your tastes and comfort. We don't believe in one-size-fits-all
          holidays.
        </p>
        <p>
          Whether it's a special request or a last-minute change, our priority is
          to make your vacation smooth, meaningful, and memorable.
        </p>
        <p>
          With us, you are <strong>Supported, Informed, and Valued</strong> from
          start to finish.
        </p>

        <a href="/about">
          <button
            style={{
              marginTop: "25px",
              padding: "14px 32px",
              borderRadius: "8px",
              backgroundColor: "var(--color-primary)",
              color: "white",
              border: "none",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Let's Explore
          </button>
        </a>
      </div>
    </>
  );
};

export default ImageHero;